import '../css/DesktopCategoriesBar.css';
import BrandFilter from './BrandFilter';
import PriceFilter from './PriceFilter';

export default function DesktopCategoriesBar ({language, priceRange, handlePriceChange, maxPrice, options, selectedBrands, loading, handleCheckboxChange}) {
    const categories = {
        'pain_killers': (language === 'arabic') ? 'مسكنات الألم' : 'Pain Killers',
        'vitamins': (language === 'arabic') ? 'الفيتامينات' : 'Vitamins',
        'colds': (language === 'arabic') ? 'سعال البرد' : 'Cold/Cough',
        'body_care': (language === 'arabic') ? 'العناية بالجسم' : 'Body Care',
        'hygiene': (language === 'arabic') ? 'صحة' : 'Hygiene',
        'first_aid': (language === 'arabic') ? 'إسعافات أولية' : 'First Aid',
    };

    return (
        <aside id="listAside">
            <h5 style={{ color: 'green', marginLeft: '2.5%', marginTop: '2.5%', fontWeight: '300' }}>
                {language === 'arabic' ? 'فئات' : 'Categories'}
            </h5>
            <ul>
                {Object.entries(categories).map(([catKey, catName]) => (
                    <li key={catKey}>
                        <a href={`/product/category/${catKey}`}>
                            {catName}
                        </a>
                    </li>
                ))}
            </ul>
            <hr/>
            <BrandFilter {...{ options, selectedBrands, loading, handleCheckboxChange }} />
            <hr/>
            <PriceFilter {...{ priceRange, handlePriceChange, maxPrice }} />
        </aside>
    )
}